export default __webpack_public_path__ + "static/media/img-9.8f3fc12e.jpg";